import { SET_EXAM, SET_EXAMS, UNSET_EXAM, UNSET_EXAMS } from 'constant';

export const setExam = (exam) => ({ type: SET_EXAM, payload: exam });

export const setExams = (exams) => ({ type: SET_EXAMS, payload: exams });

export const unsetExam = () => ({ type: UNSET_EXAM });

export const unsetExams = () => ({ type: UNSET_EXAMS });
